module.exports = __webpack_public_path__ + "img/en_compt.1d1edf27.svg";